import { render, staticRenderFns } from "./logo_champion-LA.vue?vue&type=template&id=0bba6b3a&"
import script from "./logo_champion-LA.vue?vue&type=script&lang=js&"
export * from "./logo_champion-LA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports